import { cssMap } from '@atlaskit/css';

import { Inline, Text } from '@atlaskit/primitives/compiled';

import { token } from '@atlaskit/tokens';

import { type JSX } from 'react/jsx-runtime';

const styles = cssMap({
	container: {
		paddingRight: token('space.050'),
	},
});

const completedDotStyles = [
	'#FCA700',
	'#AF59E1',
	'#1868DB',
	'#6A9A23',
	'#FCA700',
	'#AF59E1',
	'#1868DB',
	'#6A9A23',
	'#FCA700',
] as const;

type ProgressDotsProps = {
	totalSteps: number;
	completedSteps: number;
};

export const ProgressDots = ({ totalSteps, completedSteps }: ProgressDotsProps): JSX.Element => {
	return (
		<Inline space="space.150" alignBlock="center" xcss={styles.container}>
			{Array.from({ length: totalSteps }, (_, index) => {
				const isCompleted = index < completedSteps;
				return (
					<div
						key={index}
						style={{
							width: '0.5rem',
							height: '0.5rem',
							borderRadius: token('radius.full'),
							transition: 'background-color 0.3s ease',
							backgroundColor: isCompleted
								? completedDotStyles[index]
								: token('color.background.neutral'),
						}}
					/>
				);
			})}
			<Text size="small" color="color.text.subtlest" weight="medium" maxLines={1}>
				{completedSteps} OF {totalSteps} COMPLETE
			</Text>
		</Inline>
	);
};
